<template>
  <!--NAVBAR-->
  <div class="flex flex-col h-32 items-center pt-4 pl-1 md:flex-row md:pl-20">
    <Link href="/">
      <div class="flex flex-col items-center p-2 md:pr-8">
        <svg
          class="text-gray-900"
          width="80"
          height="40"
          viewBox="0 0 90 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 39.6452C10.7548 39.6452 14.1903 38.3064 14.5637 37.637L29.1275 26.1296M78.4201 33.1186L57.1346 4L29.1275 26.1296M29.1275 9.52249V26.1296"
            stroke="currentColor"
            stroke-width="4"
          />
        </svg>
        <p class="text-xs font-medium text-gray-900">Ubytování</p>
      </div>
    </Link>
    <div class="flex pt-4 md:pt-0">
      <Link
        class="px-2 text-xl text-gray-900 cool-link md:px-4 hover:text-900"
        href="/rezervace"
        >Rezervace</Link
      >
      <Link
        class="px-2 text-xl text-gray-900 cool-link md:px-4 hover:text-900"
        href="/cenik"
        >Ceník</Link
      >
      <Link
        class="px-2 text-xl text-gray-900 cool-link md:px-4 hover:text-900"
        href="/galerie"
        >Galerie</Link
      >
    </div>
  </div>
</template>

<script>

import { Link } from '@inertiajs/inertia-vue3'

  export default {

    components: {
      Link
    }
  }
</script>
